import {NgModule} from '@angular/core';
import {CommonModule, CurrencyPipe, TitleCasePipe} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import {NavbarComponent} from './components/navbar/navbar.component';
import {EviComponent} from './components/evi/evi.component';
import {InsuredItemsTabDetailComponent} from './components/insured-items-tab-detail/insured-items-tab-detail.component';
import {PausePolicyComponent} from './components/policy-actions/pause-resume-policy/pause-policy/pause-policy.component';
import {ResumePolicyComponent} from './components/policy-actions/pause-resume-policy/resume-policy/resume-policy.component';
import {CancelModalComponent} from './components/cancel-modal/cancel-modal.component';
import {QuestionEditComponent} from './components/question-edit/question-edit.component';

import {QuestionComponent} from './components/question/question.component';
import {SearchComponent} from './components/search/search.component';
import {GoogleMapsModule} from '@angular/google-maps';
import {LottieComponent} from 'ngx-lottie';
import player from 'lottie-web';
import {CancelPolicyComponent} from './components/policy-actions/cancel-restore-policy/cancel-policy/cancel-policy.component';
import {RestorePolicyComponent} from './components/policy-actions/cancel-restore-policy/restore-policy/restore-policy.component';
import {InsurerRatingComponent} from './components/insurer-rating/insurer-rating.component';
import {SliderComponent} from './components/slider/slider.component';
import {VapEditComponent} from './components/vap-edit/vap-edit.component';
import {NgxMaskDirective, NgxMaskPipe} from 'ngx-mask';
import {PolicyHoldersComponent} from './components/policy-holders/policy-holders.component';
import {GlobalSearchComponent} from './components/global-search/global-search.component';
import {EmergencyServicesModalComponent} from '../claim/emergency-services-modal/emergency-services-modal.component';
import {ComplianceVaultComponent} from './components/compliance-vault/compliance-vault.component';
import {BrokerResourcesComponent} from './components/broker-resources/broker-resources.component';
import {BrokerDashboardComponent} from './components/broker-dashboard/broker-dashboard.component';
import { SidesheetComponent } from './components/sidesheet/sidesheet.component';
import { QuotePickCoverFooterComponent } from '../quotes/quote-pick-cover-footer/quote-pick-cover-footer.component';
import {DocBrokerAppointmentLetterComponent} from './documentation/components/doc-broker-appointment-letter/doc-broker-appointment-letter.component';
import {DocDebitOrderAuthorityComponent} from './documentation/components/doc-debit-order-authority/doc-debit-order-authority.component';
import {DocPolicyStatementComponent} from './documentation/components/doc-policy-statement/doc-policy-statement.component';
import {DocTaxInvoiceComponent} from './documentation/components/doc-tax-invoice/doc-tax-invoice.component';
import {DocTermsAndConditionsComponent} from './documentation/components/doc-terms-and-conditions/doc-terms-and-conditions.component';
import {DocProfessionalFeeAgreementComponent} from './documentation/components/doc-professional-fee-agreement/doc-professional-fee-agreement.component';
import {DocPrivacyPolicyComponent} from './documentation/components/doc-privacy-policy/doc-privacy-policy.component';
import {DocCookiesPolicyComponent} from './documentation/components/doc-cookies-policy/doc-cookies-policy.component';
import {DocSideNavComponent} from './documentation/components/doc-side-nav/doc-side-nav.component';
import {QuestionCheckboxMultipleComponent} from './questions/question-checkbox-multiple/question-checkbox-multiple.component';
import {QuestionCheckboxSliderComponent} from './questions/question-checkbox-slider/question-checkbox-slider.component';
import {QuestionRadioComponent} from './questions/question-radio/question-radio.component';
import {QuestionRegVinComponent} from './questions/question-reg-vin/question-reg-vin.component';
import {QuestionYesNoComponent} from './questions/question-yes-no/question-yes-no.component';
import {QuestionRadioFormComponent} from './questions/question-radio-form/question-radio-form.component';
import {QuestionMiniFlowSidesheetComponent} from './questions/question-mini-flow-sidesheet/question-mini-flow-sidesheet.component';
import {QuestionUwModalComponent} from './questions/question-uw-modal/question-uw-modal.component';
import {QuestionSampleComponent} from './questions/question-sample/question-sample.component';
import {QuestionCsvUploadComponent} from './questions/question-csv-upload/question-csv-upload.component';
import {QuestionControllerComponent} from './questions/question-controller/question-controller.component';
import {QuestionSliderComponent} from './questions/question-slider/question-slider.component';
import {QuestionSliderGenericComponent} from './questions/question-slider-generic/question-slider-generic.component';
import {QuestionTextboxComponent} from './questions/question-textbox/question-textbox.component';
import {QuestionTrafficCopComponent} from './questions/question-traffic-cop/question-traffic-cop.component';
import {QuestionTrafficCop2Component} from './questions/question-traffic-cop-2/question-traffic-cop-2.component';
import {QuestionSuperTrafficCopComponent} from './questions/question-super-traffic-cop/question-super-traffic-cop.component';
import {QuestionAddressComponent} from './questions/question-address/question-address.component';
import {QuestionAddressTextboxComponent} from './questions/question-address-textbox/question-address-textbox.component';
import {DocDocumentComponent} from './documentation/components/doc-document/doc-document.component';
import {QuestionSliderParentComponent} from './questions/question-slider-parent/question-slider-parent.component';
import {SafeHtmlPipe} from './safe-html.pipe';
import {SafeUrlPipe} from './safe-url.pipe';
import {QuestionDropdownComponent} from './questions/question-dropdown/question-dropdown.component';
import {QuestionDropdownCurrencyComponent} from './questions/question-dropdown-currency/question-dropdown-currency.component';
import {NumberOtpComponent} from './components/number-otp/number-otp.component';
import {QuestionPercentageVariationTwoComponent} from './questions/question-percentage-variation-two/question-percentage-variation-two.component';
import {QuestionPercentageVariationOneComponent} from './questions/question-percentage-variation-one/question-percentage-variation-one.component';
import {QuestionDateOfBirthComponent} from './questions/question-date-of-birth/question-date-of-birth.component';
import {QuestionToggleButtonComponent} from './questions/question-toggle-button/question-toggle-button.component';
import {QuestionRadioColumnComponent} from './questions/question-radio-column/question-radio-column.component';
import {QuestionRadioColumnParentComponent} from './questions/question-radio-column-parent/question-radio-column-parent.component';
import {QuestionTogglePillsComponent} from './questions/question-toggle-pills/question-toggle-pills.component';
import {QuestionPillButtonsComponent} from './questions/question-pill-buttons/question-pill-buttons.component';
import {QuestionLocationComponent} from './questions/question-location/question-location.component';
import {QuestionSpecifiedItemsComponent} from './questions/question-specified-items/question-specified-items.component';
import {QuestionRadioIconsComponent} from './questions/question-radio-icons/question-radio-icons.component';
import {QuestionUploadComponent} from './questions/question-uploaders/question-upload.component';
import {QuestionInterstitialComponent} from './questions/question-interstitial/question-interstitial.component';
import {QuestionRebuildCostComponent} from './questions/question-rebuild-cost/question-rebuild-cost.component';
import {QuestionPlusMinusComponent} from './questions/question-plus-minus/question-plus-minus.component';
import {QuestionMinMaxTextboxComponent} from './questions/question-min-max-textbox/question-min-max-textbox.component';
import {QuestionFlowControllerComponent} from './questions/question-flow-controller/question-flow-controller.component';
import {QuestionRadioImageDetailsComponent} from './questions/question-radio-image-details/question-radio-image-details.component';
import {QuestionProductSelectComponent} from './questions/question-product-select/question-product-select.component';
import {QuestionSelectButtonComponent} from './questions/question-select-button/question-select-button.component';
import {QuestionCheckboxSearchListComponent} from './questions/question-checkbox-search-list/question-checkbox-search-list.component';
import {QuestionSearchListComponent} from './questions/question-search-list/question-search-list.component';
import {QuestionAutocompleteComponent} from './questions/question-autocomplete/question-autocomplete.component';
import {QuestionAutocompleteGenericComponent} from './questions/question-autocomplete-generic/question-autocomplete-generic.component';
import {QuestionCheckboxImageComponent} from './questions/question-checkbox-image/question-checkbox-image.component';
import {QuestionCheckboxMiniFormComponent} from './questions/question-checkbox-miniform/question-checkbox-miniform.component';
import {QuestionFuneralPolicyMemberComponent} from './questions/question-funeral-policy-member/question-funeral-policy-member.component';
import {QuestionDatePickerComponent} from './questions/question-date-picker/question-date-picker.component';
import {QuestionSummaryComponent} from './questions/question-summary/question-summary.component';
import {QuestionQuoteLoaderComponent} from './questions/question-quote-loader/question-quote-loader.component';
import {QuestionQuotePayComponent} from './questions/question-quote-pay/question-quote-pay.component';
import {QuestionQuoteComponent} from './questions/question-quote/question-quote.component';
import {QuestionSummaryNoCalcComponent} from './questions/question-summary-nocalc/question-summary-nocalc.component';
import {SummaryEditModalComponent} from './components/summary-edit-modal/summary-edit-modal.component';
import {EditModalComponent} from './components/edit-modal/edit-modal.component';
import {AddBenefitsComponent} from './components/add-benefits/add-benefits.component';
import {QuestionTextareaComponent} from './questions/question-textarea/question-textarea.component';
import {QuestionCurrencyComponent} from './questions/question-currency/question-currency.component';
import {QuestionVehicleRiskListComponent} from './questions/question-vehicle-risk-list/question-vehicle-risk-list.component';
import { NgxCurrencyDirective } from 'ngx-currency';
import {QuestionLabelAmountParentComponent} from './questions/question-label-amount-parent/question-label-amount-parent.component';
import {QuestionLabelAmountJsonComponent} from './questions/question-label-amount-json/question-label-amount-json.component';
import {QuestionLabelPercentJsonComponent} from './questions/question-label-percent-json/question-label-percent-json.component';
import {QuestionGenericParentComponent} from './questions/question-generic-parent/question-generic-parent.component';
import {QuestionToggleParentComponent} from './questions/question-toggle-parent/question-toggle-parent.component';
import {QuestionFamilyListComponent} from './questions/question-family-list/question-family-list.component';
import {QuestionCompanyRegistrationComponent} from './questions/question-company-registration/question-company-registration.component';
import {QuestionTextboxIconComponent} from './questions/question-textbox-icon/question-textbox-icon.component';
import {QuestionYearComponent} from './questions/question-year/question-year.component';
import {QuestionTelComponent} from './questions/question-tel/question-tel.component';
import {QuestionMiniFormComponent} from './questions/question-mini-form/question-mini-form.component';
import {SidebarComponent} from './components/sidebar/sidebar.component';
import {CheckTokenComponent} from './components/check-token/check-token.component';
import {ClaimTranscriptComponent} from './components/claim-transcript/claim-transcript.component';
import {EditProfileComponent} from './components/edit-profile/edit-profile.component';
import {QuestionMultiselectItemsComponent} from './questions/question-multiselect-items/question-multiselect-items.component';
import {QuestionMultiselectBenefitsComponent} from './questions/question-multiselect-benefits/question-multiselect-benefits.component';
import {QuestionPledgeComponent} from './questions/question-pledge/question-pledge.component';
import {QuestionWitnessDetailsComponent} from './questions/question-witness-details/question-witness-details.component';
import {QuestionOdometerReadingComponent} from './questions/question-odometer-reading/question-odometer-reading.component';
import {QuestionSecurityCodeComponent} from './questions/question-security-code/question-security-code.component';
import {QuestionGroupedMultiSelectComponent} from './questions/question-grouped-multiselect/question-grouped-multiselect.component';
import {QuestionImagesOfDamageComponent} from './questions/question-images-of-damage/question-images-of-damage.component';
import {QuestionInterstitialVariationOneComponent} from './questions/question-interstitial-variation-one/question-interstitial-variation-one.component';
import {QuestionInterstitialGenericComponent} from './questions/question-interstitial-generic/question-interstitial-generic.component';
import {QuestionTimepickerComponent} from './questions/question-timepicker/question-timepicker.component';
import {QuestionInputTimepickerComponent} from './questions/question-input-timepicker/question-input-timepicker.component';
import {LandingLeftSidebarComponent} from './components/landing-left-sidebar/landing-left-sidebar.component';
import {QuestionMultiselectGroupedComponent} from './questions/question-multiselect-grouped/question-multiselect-grouped.component';
import {QuestionItemsSpecifyComponent} from './questions/question-items-specify/question-items-specify.component';
import {QuestionParentVariationOneComponent} from './questions/question-parent-variation-one/question-parent-variation-one.component';
import {QuestionUnspecifiedItemSpecifyComponent} from './questions/question-unspecified-item-specify/question-unspecified-item-specify.component';
import {QuestionInterstitialScreenVariationTwoComponent} from './questions/question-interstitial-screen-variation-two/question-interstitial-screen-variation-two.component';
import {QuestionParentVariationTwoComponent} from './questions/question-parent-variation-two/question-parent-variation-two.component';
import {QuestionUploaderVariationOneComponent} from './questions/question-uploader-variation-one/question-uploader-variation-one.component';
import {QuestionClaimSummaryComponent} from './questions/question-claim-summary/question-claim-summary.component';
import {QuestionIndustryOccupationComponent} from './questions/question-industry-occupation/question-industry-occupation.component';
import {QuestionVehicleMakeYearModelComponent} from './questions/question-vehicle-make-year-model/question-vehicle-make-year-model.component';
import {QuestionVerifyEmailComponent} from './questions/question-verify-email/question-verify-email.component';
import {QuestionEmailComponent} from './questions/question-email/question-email.component';
import {VapsLocationOneComponent} from './questions/vaps/vaps-location-one/vaps-location-one.component';
import {VapsLocationTwoComponent} from './questions/vaps/vaps-location-two/vaps-location-two.component';
import {VapsLocationThreeBuildingsComponent} from './questions/vaps/vaps-location-three-buildings/vaps-location-three-buildings.component';
import {VapsLocationThreeContentsComponent} from './questions/vaps/vaps-location-three-contents/vaps-location-three-contents.component';
import {VapsLocationFourComponent} from './questions/vaps/vaps-location-four/vaps-location-four.component';
import {VapsLocationFiveComponent} from './questions/vaps/vaps-location-five/vaps-location-five.component';
import {VapsLocationSixComponent} from './questions/vaps/vaps-location-six/vaps-location-six.component';
import {QuestionSelectorComponent} from './questions/question-selector/question-selector.component';
import {VapsGeneralOneComponent} from './questions/vaps/vaps-general-one/vaps-general-one.component';
import {VapsGeneralTwoComponent} from './questions/vaps/vaps-general-two/vaps-general-two.component';
import {VapsGeneralThreeComponent} from './questions/vaps/vaps-general-three/vaps-general-three.component';
import {VapsGeneralFourComponent} from './questions/vaps/vaps-general-four/vaps-general-four.component';
import {VapsGeneralFiveComponent} from './questions/vaps/vaps-general-five/vaps-general-five.component';
import {VapsGeneralSixComponent} from './questions/vaps/vaps-general-six/vaps-general-six.component';
import {VapsGeneralSevenComponent} from './questions/vaps/vaps-general-seven/vaps-general-seven.component';
import {VapsGeneralEightComponent} from './questions/vaps/vaps-general-eight/vaps-general-eight.component';
import {VapsGeneralNineComponent} from './questions/vaps/vaps-general-nine/vaps-general-nine.component';
import {VapsGeneralTenComponent} from './questions/vaps/vaps-general-ten/vaps-general-ten.component';
import {VapsGeneralElevenComponent} from './questions/vaps/vaps-general-eleven/vaps-general-eleven.component';
import {VapsVehicleOneComponent} from './questions/vaps/vaps-vehicle-one/vaps-vehicle-one.component';
import {VapsVehicleTwoComponent} from './questions/vaps/vaps-vehicle-two/vaps-vehicle-two.component';
import {VapsVehicleThreeComponent} from './questions/vaps/vaps-vehicle-three/vaps-vehicle-three.component';
import {VapsVehicleFourComponent} from './questions/vaps/vaps-vehicle-four/vaps-vehicle-four.component';
import {VapsVehicleFiveComponent} from './questions/vaps/vaps-vehicle-five/vaps-vehicle-five.component';
import {VapsFuneralOneComponent} from './questions/vaps/vaps-funeral-one/vaps-funeral-one.component';
import {VapsFuneralTwoComponent} from './questions/vaps/vaps-funeral-two/vaps-funeral-two.component';
import {VapsFuneralThreeComponent} from './questions/vaps/vaps-funeral-three/vaps-funeral-three.component';
import {AutocompleteDirective} from './autocomplete.directive';
import {QuestionUploadersImagesComponent} from './questions/question-uploaders-images/question-uploaders-images.component';
import {QuestionUploadersVideosComponent} from './questions/question-uploaders-videos/question-uploaders-videos.component';
import {QuestionUploadersSelfieComponent} from './questions/question-uploaders-selfie/question-uploaders-selfie.component';
import {QuestionUploadersDocumentsComponent} from './questions/question-uploaders-documents/question-uploaders-documents.component';
import {QuestionDamageImageTopComponent} from './questions/damage-images/question-damage-image-top/question-damage-image-top.component';
import {QuestionDamageImageFrontComponent} from './questions/damage-images/question-damage-image-front/question-damage-image-front.component';
import {QuestionDamageImageBackComponent} from './questions/damage-images/question-damage-image-back/question-damage-image-back.component';
import {QuestionDamageImageLeftComponent} from './questions/damage-images/question-damage-image-left/question-damage-image-left.component';
import {QuestionDamageImageRightComponent} from './questions/damage-images/question-damage-image-right/question-damage-image-right.component';
import {QuestionDamageImageLeftFrontFenderComponent} from './questions/damage-images/question-damage-image-left-front-fender/question-damage-image-left-front-fender.component';
import {QuestionDamageImageLeftBackFenderComponent} from './questions/damage-images/question-damage-image-left-back-fender/question-damage-image-left-back-fender.component';
import {QuestionDamageImageRightBackFenderComponent} from './questions/damage-images/question-damage-image-right-back-fender/question-damage-image-right-back-fender.component';
import {QuestionDamageImageRightFrontFenderComponent} from './questions/damage-images/question-damage-image-right-front-fender/question-damage-image-right-front-fender.component';
import {QuestionDamageImagePartComponent} from './questions/damage-images/question-damage-image-part/question-damage-image-part.component';
import {QuestionDamageImageParentComponent} from './questions/damage-images/question-damage-image-parent/question-damage-image-parent.component';
import {QuestionLabelTextboxParentComponent} from './questions/question-label-textbox-parent/question-label-textbox-parent.component';
import {QuestionLabelPercentageComponent} from './questions/question-label-percentage/question-label-percentage.component';
import {QuestionLabelAmountComponent} from './questions/question-label-amount/question-label-amount.component';
import {QuestionSuperVapsControlComponent} from './questions/question-super-vaps-control/question-super-vaps-control.component';
import {QuestionTextboxPercentageComponent} from './questions/question-textbox-percentage/question-textbox-percentage.component';
import {QuestionTextboxAmountComponent} from './questions/question-textbox-amount/question-textbox-amount.component';
import {QuestionMultipleDatePickerComponent} from './questions/question-multiple-date-picker/question-multiple-date-picker.component';
import {QuestionMiniFlowControllerComponent} from './questions/question-mini-flow/question-mini-flow-controller.component';
import {DamageImagesModalAltComponent} from './components/damage-images-modal-alt/damage-images-modal-alt.component';
import {DamageImagesModalComponent} from './components/damage-images-modal/damage-images-modal.component';
import {QuestionPercentageTextboxComponent} from './questions/question-percentage-textbox/question-percentage-textbox.component';
import {QuestionMultiDropdownPercComponent} from './questions/question-multi-dropdown-perc/question-multi-dropdown-perc.component';
import {QuestionNumberTextboxComponent} from './questions/question-number-textbox/question-number-textbox.component';
import {QuestionItemsListComponent} from './questions/question-items-list/question-items-list.component';
import {QuestionClaimSummaryUpdateComponent} from './questions/question-claim-summary-update/question-claim-summary-update.component';
import {QuestionClaimConfirmationComponent} from './questions/question-claim-confirmation/question-claim-confirmation.component';
import {EventDetailsComponent} from './questions/question-claim_summary_components/event-details/event-details.component';
import {ItemDetailsComponent} from './questions/question-claim_summary_components/item-details/item-details.component';
import {ItemUpdateModalComponent} from './questions/question-claim_summary_components/item-update-modal/item-update-modal.component';
import {RequestCallComponent} from './components/request-call/request-call.component';
import {QuestionClaimsItemsListComponent} from './questions/question-claims-items-list/question-claims-items-list.component';
import {DataTablesModule} from 'angular-datatables';
import {AutofocusDirective} from './autofocus.directive';
import {ClaimEditModalComponent} from './components/claim-edit-modal/claim-edit-modal.component';
import {CommercialEditComponent} from './components/commercial-edit/commercial-edit.component';
import {ClamEditItemDetailsComponent} from './components/claim-edit-modal/partials/clam-edit-item-details/clam-edit-item-details.component';
import {ClamEditEventDetailsComponent} from './components/claim-edit-modal/partials/clam-edit-event-details/clam-edit-event-details.component';
import {QuestionOrControlComponent} from './questions/question-or-control/question-or-control.component';
import {QuestionLocationEditComponent} from './questions/question-location-edit/question-location-edit.component';
import {QuestionGenericMiniflowParentComponent} from './questions/question-generic-miniflow-parent/question-generic-miniflow-parent.component';
import {OnBoardingModalComponent} from './components/onBoarding-modal/onBoarding-modal.component';
import {DocPolicyQuoteComponent} from './documentation/components/doc-policy-quote/doc-policy-quote.component';
import {VapsMiniFlowParentComponent} from './questions/vaps/vaps-mini-flow-parent/vaps-mini-flow-parent.component';
import {VapsMiniFlowPlayerComponent} from './questions/vaps/vaps-mini-flow-player/vaps-mini-flow-player.component';
import {DisclaimerComponent} from './components/disclaimer/disclaimer.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {QuestionAddNoteModalComponent} from './components/question-add-note-modal/question-add-note-modal.component';
import {QuestionMiniFormModalComponent} from './components/question-mini-form-modal/question-mini-form-modal.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { QuestionRedirectToUrlComponent } from './questions/question-redirect-to-url/question-redirect-to-url.component';
import { QuestionGenericParentStackedComponent } from './questions/question-generic-parent-stacked/question-generic-parent-stacked.component';
import { CommercialAddLocationComponent } from './components/commercial-add-location/commercial-add-location.component';
import { DisclosureNoticeComponent } from './components/disclosure-notice/disclosure-notice.component';
import { QRCodeComponent } from 'angularx-qrcode';
import {DocumentsComponent} from './components/documents/documents.component';
import {DocumentsGeneralComponent} from './components/documents-general/documents-general.component';
import {PolicyDocumentsComponent} from './components/policy-documents/policy-documents.component';
import { AddonModalComponent } from './components/addon-modal/addon-modal.component';
import { FallbackImageDirective } from './fallback-image.directive';
import { ClaimInitiatedGuardModalComponent } from './components/claim-initiated-guard-modal/claim-initiated-guard-modal.component';
import {AssignBrokerModalComponent} from './components/assign-broker-modal/assign-broker-modal.component';
import {NotificationsLandingComponent} from './components/notifications-landing/notifications-landing.component';


export const options: any = {};
export const playerFactory = () => player;

@NgModule({ declarations: [
        FallbackImageDirective,
        RequestCallComponent,
        NavbarComponent,
        EviComponent,
        InsuredItemsTabDetailComponent,
        PausePolicyComponent,
        ResumePolicyComponent,
        CancelModalComponent,
        SearchComponent,
        CancelPolicyComponent,
        RestorePolicyComponent,
        CancelPolicyComponent,
        QuestionComponent,
        QuestionEditComponent,
        InsurerRatingComponent,
        SliderComponent,
        CheckTokenComponent,
        EditProfileComponent,
        VapEditComponent,
        PolicyHoldersComponent,
        EmergencyServicesModalComponent,
        DocBrokerAppointmentLetterComponent,
        BrokerResourcesComponent,
        DocDebitOrderAuthorityComponent,
        DocPolicyStatementComponent,
        DocTaxInvoiceComponent,
        DocTermsAndConditionsComponent,
        DocProfessionalFeeAgreementComponent,
        DocPrivacyPolicyComponent,
        DocCookiesPolicyComponent,
        DocSideNavComponent,
        QuestionCheckboxMultipleComponent,
        QuestionMiniFormModalComponent,
        QuestionRadioComponent,
        QuestionRegVinComponent,
        QuestionYesNoComponent,
        QuestionRadioFormComponent,
        QuestionMiniFlowSidesheetComponent,
        QuestionUwModalComponent,
        QuestionSampleComponent,
        QuestionCsvUploadComponent,
        QuestionControllerComponent,
        QuestionSliderComponent,
        QuestionSliderGenericComponent,
        QuestionTextboxComponent,
        QuestionMiniFormComponent,
        QuestionAddressComponent,
        QuestionAddressTextboxComponent,
        QuestionGenericParentComponent,
        QuestionGenericParentStackedComponent,
        DocDocumentComponent,
        CommercialEditComponent,
        CommercialAddLocationComponent,
        SafeHtmlPipe,
        SafeUrlPipe,
        QuestionSliderParentComponent,
        QuestionDatePickerComponent,
        NumberOtpComponent,
        QuestionDropdownComponent,
        QuestionDropdownCurrencyComponent,
        QuestionPercentageVariationTwoComponent,
        QuestionPercentageVariationOneComponent,
        QuestionDateOfBirthComponent,
        QuestionToggleButtonComponent,
        QuestionRadioColumnComponent,
        QuestionRadioColumnParentComponent,
        QuestionTogglePillsComponent,
        QuestionPillButtonsComponent,
        QuestionLocationComponent,
        QuestionSpecifiedItemsComponent,
        QuestionRadioIconsComponent,
        QuestionUploadComponent,
        QuestionCheckboxImageComponent,
        QuestionInterstitialComponent,
        QuestionInterstitialComponent,
        QuestionInterstitialGenericComponent,
        QuestionRebuildCostComponent,
        QuestionPlusMinusComponent,
        QuestionMinMaxTextboxComponent,
        QuestionFlowControllerComponent,
        QuestionRadioImageDetailsComponent,
        QuestionSelectButtonComponent,
        QuestionAutocompleteComponent,
        QuestionAutocompleteGenericComponent,
        QuestionProductSelectComponent,
        QuestionSummaryComponent,
        QuestionSummaryNoCalcComponent,
        SummaryEditModalComponent,
        EditModalComponent,
        AddBenefitsComponent,
        ClaimTranscriptComponent,
        QuestionTextareaComponent,
        QuestionCurrencyComponent,
        QuestionVehicleRiskListComponent,
        QuestionLabelAmountParentComponent,
        QuestionToggleParentComponent,
        QuestionFamilyListComponent,
        QuestionCompanyRegistrationComponent,
        QuestionTextboxIconComponent,
        QuestionYearComponent,
        QuestionTelComponent,
        SidebarComponent,
        QuestionMultiselectItemsComponent,
        QuestionMultiselectBenefitsComponent,
        QuestionPledgeComponent,
        QuestionWitnessDetailsComponent,
        QuestionOdometerReadingComponent,
        QuestionSecurityCodeComponent,
        QuestionGroupedMultiSelectComponent,
        QuestionImagesOfDamageComponent,
        QuestionInterstitialVariationOneComponent,
        QuestionTimepickerComponent,
        QuestionInputTimepickerComponent,
        QuestionMultiselectGroupedComponent,
        QuestionItemsSpecifyComponent,
        QuestionParentVariationOneComponent,
        QuestionUnspecifiedItemSpecifyComponent,
        QuestionInterstitialScreenVariationTwoComponent,
        QuestionParentVariationTwoComponent,
        QuestionUploaderVariationOneComponent,
        QuestionTimepickerComponent,
        LandingLeftSidebarComponent,
        QuestionClaimSummaryComponent,
        QuestionVehicleMakeYearModelComponent,
        QuestionVerifyEmailComponent,
        QuestionEmailComponent,
        QuestionSelectorComponent,
        VapsLocationOneComponent,
        VapsLocationTwoComponent,
        VapsLocationThreeBuildingsComponent,
        VapsLocationThreeContentsComponent,
        VapsLocationFourComponent,
        VapsLocationFiveComponent,
        VapsLocationSixComponent,
        VapsGeneralOneComponent,
        VapsGeneralTwoComponent,
        VapsGeneralThreeComponent,
        VapsGeneralFourComponent,
        VapsGeneralFiveComponent,
        VapsGeneralSixComponent,
        VapsGeneralSevenComponent,
        VapsGeneralEightComponent,
        VapsGeneralNineComponent,
        VapsGeneralTenComponent,
        VapsGeneralElevenComponent,
        VapsVehicleOneComponent,
        VapsVehicleTwoComponent,
        VapsVehicleThreeComponent,
        VapsVehicleFourComponent,
        VapsVehicleFiveComponent,
        VapsLocationSixComponent,
        VapsFuneralOneComponent,
        VapsFuneralTwoComponent,
        VapsFuneralThreeComponent,
        AutocompleteDirective,
        QuestionUploadersImagesComponent,
        QuestionUploadersVideosComponent,
        QuestionUploadersSelfieComponent,
        QuestionUploadersDocumentsComponent,
        QuestionDamageImageTopComponent,
        QuestionDamageImageFrontComponent,
        QuestionDamageImageBackComponent,
        QuestionDamageImageLeftComponent,
        QuestionDamageImageRightComponent,
        QuestionDamageImageLeftFrontFenderComponent,
        QuestionDamageImageLeftBackFenderComponent,
        QuestionDamageImageRightBackFenderComponent,
        QuestionDamageImageRightFrontFenderComponent,
        QuestionDamageImagePartComponent,
        QuestionDamageImageParentComponent,
        AutocompleteDirective,
        QuestionLabelTextboxParentComponent,
        QuestionLabelPercentageComponent,
        QuestionLabelAmountComponent,
        QuestionTextboxPercentageComponent,
        QuestionTextboxAmountComponent,
        QuestionMultipleDatePickerComponent,
        QuestionMiniFlowControllerComponent,
        DamageImagesModalAltComponent,
        QuestionPercentageTextboxComponent,
        QuestionNumberTextboxComponent,
        DamageImagesModalComponent,
        QuestionItemsListComponent,
        QuestionClaimSummaryUpdateComponent,
        EventDetailsComponent,
        ItemDetailsComponent,
        ItemUpdateModalComponent,
        QuestionClaimsItemsListComponent,
        AutofocusDirective,
        QuestionClaimConfirmationComponent,
        ClaimEditModalComponent,
        ClamEditItemDetailsComponent,
        ClamEditEventDetailsComponent,
        QuestionLocationEditComponent,
        QuestionGenericMiniflowParentComponent,
        QuestionOrControlComponent,
        OnBoardingModalComponent,
        DocPolicyQuoteComponent,
        VapsMiniFlowParentComponent,
        VapsMiniFlowPlayerComponent,
        OnBoardingModalComponent,
        DisclaimerComponent,
        QuestionAddNoteModalComponent,
        QuestionCheckboxSliderComponent,
        QuestionCheckboxMiniFormComponent,
        QuestionLabelAmountJsonComponent,
        QuestionLabelPercentJsonComponent,
        QuestionTrafficCopComponent,
        QuestionTrafficCop2Component,
        QuestionSuperTrafficCopComponent,
        BrokerDashboardComponent,
        GlobalSearchComponent,
        QuestionRedirectToUrlComponent,
        ComplianceVaultComponent,
        DisclosureNoticeComponent,
        DocumentsComponent,
        DocumentsGeneralComponent,
        PolicyDocumentsComponent,
        AddonModalComponent,
        QuestionSuperVapsControlComponent,
        QuestionFuneralPolicyMemberComponent,
        QuestionMultiDropdownPercComponent,
        QuestionIndustryOccupationComponent,
        QuestionCheckboxSearchListComponent,
        QuestionSearchListComponent,
        QuestionQuoteLoaderComponent,
        QuestionQuotePayComponent,
        QuestionQuoteComponent,
        SidesheetComponent,
        QuotePickCoverFooterComponent,
        ClaimInitiatedGuardModalComponent,
        AssignBrokerModalComponent,
        NotificationsLandingComponent
    ],
    exports: [
        FallbackImageDirective,
        NavbarComponent,
        EviComponent,
        RequestCallComponent,
        InsuredItemsTabDetailComponent,
        QuestionMiniFormModalComponent,
        PausePolicyComponent,
        ResumePolicyComponent,
        CancelModalComponent,
        CancelPolicyComponent,
        RestorePolicyComponent,
        EmergencyServicesModalComponent,
        QuestionEditComponent,
        QuestionComponent,
        InsurerRatingComponent,
        SliderComponent,
        CheckTokenComponent,
        EditProfileComponent,
        VapEditComponent,
        NgxMaskDirective,
        NgxMaskPipe,
        LottieComponent,
        DocBrokerAppointmentLetterComponent,
        QuestionCheckboxMultipleComponent,
        QuestionRadioComponent,
        QuestionMiniFormComponent,
        QuestionGenericParentComponent,
        QuestionGenericParentStackedComponent,
        QuestionControllerComponent,
        ClaimTranscriptComponent,
        SafeHtmlPipe,
        SafeUrlPipe,
        QuestionDatePickerComponent,
        QuestionSliderParentComponent,
        QuestionSliderGenericComponent,
        NumberOtpComponent,
        QuestionDropdownComponent,
        QuestionDropdownCurrencyComponent,
        QuestionPercentageVariationTwoComponent,
        QuestionDateOfBirthComponent,
        QuestionToggleButtonComponent,
        QuestionRadioColumnComponent,
        QuestionRadioColumnParentComponent,
        QuestionPercentageVariationOneComponent,
        QuestionTogglePillsComponent,
        QuestionPillButtonsComponent,
        QuestionLocationComponent,
        QuestionSpecifiedItemsComponent,
        QuestionRadioIconsComponent,
        QuestionUploadComponent,
        QuestionCheckboxImageComponent,
        QuestionCheckboxMiniFormComponent,
        QuestionCheckboxSliderComponent,
        QuestionInterstitialComponent,
        QuestionInterstitialGenericComponent,
        QuestionRebuildCostComponent,
        QuestionRadioImageDetailsComponent,
        QuestionSummaryComponent,
        QuestionSummaryNoCalcComponent,
        SummaryEditModalComponent,
        EditModalComponent,
        AddBenefitsComponent,
        AddonModalComponent,
        QuestionMultiselectItemsComponent,
        QuestionMultiselectBenefitsComponent,
        QuestionMinMaxTextboxComponent,
        LandingLeftSidebarComponent,
        QuestionTextboxComponent,
        QuestionTextareaComponent,
        QuestionCurrencyComponent,
        QuestionAddressComponent,
        QuestionAddressTextboxComponent,
        QuestionSliderComponent,
        QuestionOrControlComponent,
        OnBoardingModalComponent,
        VapsMiniFlowParentComponent,
        QuestionMiniFlowControllerComponent,
        DisclaimerComponent,
        CommercialEditComponent,
        CommercialAddLocationComponent,
        QuestionAutocompleteGenericComponent,
        QuestionTelComponent,
        QuestionOdometerReadingComponent,
        QuestionEmailComponent,
        QuestionVerifyEmailComponent,
        QuestionLabelTextboxParentComponent,
        QuestionLabelPercentageComponent,
        QuestionLabelAmountComponent,
        QuestionTextboxPercentageComponent,
        QuestionTextboxAmountComponent,
        QuestionLabelAmountJsonComponent,
        QuestionLabelPercentJsonComponent,
        QuestionTrafficCopComponent,
        QuestionTrafficCop2Component,
        QuestionSuperTrafficCopComponent,
        QuestionRegVinComponent,
        QuestionYesNoComponent,
        QuestionRadioFormComponent,
        QuestionMiniFlowSidesheetComponent,
        QuestionUwModalComponent,
        QuestionSampleComponent,
        QuestionCsvUploadComponent,
        QuestionRedirectToUrlComponent,
        BrokerDashboardComponent,
        GlobalSearchComponent,
        ComplianceVaultComponent,
        DisclosureNoticeComponent,
        DocumentsComponent,
        DocumentsGeneralComponent,
        PolicyDocumentsComponent,
        QuestionSuperVapsControlComponent,
        QuestionFuneralPolicyMemberComponent,
        QuestionMultiDropdownPercComponent,
        QuestionIndustryOccupationComponent,
        QuestionCheckboxSearchListComponent,
        QuestionSearchListComponent,
        QuestionIndustryOccupationComponent,
        QuestionQuoteLoaderComponent,
        QuestionQuotePayComponent,
        QuestionQuoteComponent,
        QuestionInputTimepickerComponent,
        SidesheetComponent,
        QuotePickCoverFooterComponent,
        QuestionMultipleDatePickerComponent,
        ClaimInitiatedGuardModalComponent,
        AssignBrokerModalComponent,
        NotificationsLandingComponent
    ], imports: [CommonModule,
        RouterModule,
        GoogleMapsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxCurrencyDirective,
        LottieComponent,
        NgxMaskDirective,
        NgxMaskPipe,
        DataTablesModule,
        SlickCarouselModule,
        QRCodeComponent,
        NgSelectModule,
        AngularSvgIconModule.forRoot()], providers: [
        CurrencyPipe,
        TitleCasePipe,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class SharedModule {
}
export { QuestionTrafficCopComponent };

